import "./App.css";
import {  Routes, Route } from "react-router-dom";
import { useEffect } from "react";

//Security
import Login from "./Staff/pages/Login/Login";
import { Secret } from "./Staff/pages/Login/Secret";
import { StaffProtectedRoute } from "./Staff/security/StaffProtectedRoute";
import { StaffAuthProvider } from "./Staff/security/StaffuseAuth";
import { ConsultantProtectedRoute } from "./Consultants/security/ConsultantProtectedRoute";
import { ConsultantAuthProvider } from "./Consultants/security/ConsultantUseAuth";
import { StudentAuthProvider } from "./Student/security/StudentUseAuth";
import { StudentProtectedRoute } from "./Student/security/StudentProtectedRoute";

//Pages staff only
import HomePage from "./Staff/pages/HomePage/HomePage";
import ViewSchools from "./Staff/pages/Schools/ViewSchools/ViewSchools";
import HeaderAndDrawer from "./Staff/components/HeaderAndDrawer/HeaderAndDrawer";
import LogSchoolEvent from "./Staff/pages/Schools/LogSchoolEvent/LogSchoolEvent";
import Contact from "./Staff/pages/Other/Contact";
import NoPermissions from "./Staff/pages/Other/NoPermissions";
import ViewAgencies from "./Staff/pages/Agents/ViewAgencies/ViewAgencies";
import ViewECs from "./Staff/pages/Agents/ViewECs.js/ViewECs";
import ViewRegisters from "./Staff/pages/Registers/ViewRegisters/ViewRegisters";
import ViewAttendee from "./Staff/pages/Registers/ViewAttendee/ViewAttendee";
import ViewOrders from "./Staff/pages/Shopify/ViewOrders/ViewOrders";
import ViewAgency from "./Staff/pages/Agents/ViewAgency/ViewAgency";
import ViewEC from "./Staff/pages/Agents/ViewEC/ViewEC";
import ViewInvoices from "./Staff/pages/Xero/ViewInvoices/ViewInvoices";
import ViewSchool from "./Staff/pages/Schools/ViewSchool.js/ViewSchool";
import ViewInvoice from "./Staff/pages/Xero/ViewInvoice.js/ViewInvoice";
import ViewWebinar from "./Staff/pages/Zoom/ViewWebinar/ViewWebinar";
import ViewSchoolEventsOld from "./Staff/pages/Schools/ViewSchoolEventsOld.js/ViewSchoolEventsOld";
import ViewTransactions from "./Staff/pages/Xero/ViewTransactions/ViewTransactions";
import ViewTransaction from "./Staff/pages/Xero/ViewTransaction/ViewTransaction";
import ImportTransactions from "./Staff/pages/Xero/ImportTransactions.js/ImportTransactions";
import PowerBISchools from "./Staff/pages/PowerBI/PowerBISchools/PowerBISchools";
import PowerBIPartnerships from "./Staff/pages/PowerBI/PowerBIPartnerships/PowerBIPartnerships";
import PowerBIInvoices from "./Staff/pages/PowerBI/PowerBIInvoices/PowerBIInvoices";
import PowerBIMasterSales from "./Staff/pages/PowerBI/PowerBIMasterSales/PowerBIMasterSales";
import PowerBILogs from "./Staff/pages/PowerBI/PowerBILogs/PowerBILogs";
import PowerBISTX from "./Staff/pages/PowerBI/PowerBISTX/PowerBISTX";
import PowerBIRegisters from "./Staff/pages/PowerBI/PowerBIRegisters/PowerBIRegisters";
import ImportTCSCertificates from "./Staff/pages/Emails/ImportTCSCertificates/ImportTCSCertificates";
import InvoiceReminders from "./Staff/pages/Emails/InvoiceReminders/InvoiceReminders";
import TCSCertificates from "./Staff/pages/Emails/TCSCertificates/TCSCertificates";
import ViewSEFReview from "./Staff/pages/SEF/ViewSEFReview/ViewSEFReview";
import SEFRegisters from "./Staff/pages/SEF/SEFRegisters/SEFRegisters";
import AssignSchoolToHubSpot from "./Staff/pages/Misc/AssignSchoolToHubSpot/AssignSchoolToHubSpot";
import SEFEmails from "./Staff/pages/Emails/SEFEmails/SEFEmails";
import ViewPortalEmails from "./Staff/pages/Emails/ViewPortalEmails/ViewPortalEmails";
import AssignAttendeeToSchool from "./Staff/pages/Misc/AssignAttendeeToSchool/AssignAttendeeToSchool";
import AssignSchoolToCountry from "./Staff/pages/Misc/AssignSchoolToCountry/AssignSchoolToCountry";
import AssignSXPAttendeeToSchool from "./Staff/pages/Misc/AssignSXPAttendeeToSchool.js/AssignSXPAttendeeToSchool";
import SummerLetters from "./Staff/pages/Emails/SummerLetters/SummerLetters";
import ProgrammeList from "./Staff/pages/Settings/ProgrammeList/ProgrammeList";
import ArrivalDepartureEmails from "./Staff/pages/Emails/ArrivalDepartureEmails/ArrivalDepartureEmails";
import GSPBookingEmails from "./Staff/pages/Emails/GSPBookingEmails/GSPBookingEmails";
import ArrivalDepartureHome from "./Staff/pages/ArrivalDeparture/ArrivalDepartureHome.js/ArrivalDepartureHome";
import LiveTable from "./Staff/pages/Registers/LiveTable/LiveTable";
import ArrivalDepartureConfirmationEmails from "./Staff/pages/Emails/ArrivalDepartureConfirmationEmails/ArrivalDepartureConfirmationEmails";
import CurtAI from "./Staff/pages/CurtAI/CurtiAI/CurtAI";

//Student
import LoginStudent from "./Student/pages/Login/LoginStudent";
import HomePageStudent from "./Student/pages/HomePage/HomePageStudent";
import StudentHeaderAndDrawer from "./Student/components/HeaderAndDrawer/StudentHeaderAndDrawer";
import ViewBasicInfo from "./Student/pages/WEF/ViewBasicInfo.js/ViewBasicInfo";
import ViewGeneralInfo from "./Student/pages/WEF/ViewGeneralInfo/ViewGeneralInfo";
import ViewEmergancyMedicalInfo from "./Student/pages/WEF/ViewEmergancyMedicalInfo/EmergancyMedicalInfo";
import ViewSENDInfo from "./Student/pages/WEF/ViewSENDInfo/ViewSENDInfo";
import ViewPermissionsInfo from "./Student/pages/WEF/ViewPermissionsInfo/ViewPermissionsInfo";
import ViewContactInfo from "./Student/pages/WEF/ViewContactInfo/ViewContactInfo";
import ViewSEFGeneralInfo from "./Student/pages/SEF/ViewSEFGeneralInfo/ViewSEFGeneralInfo";
import ViewSEFBasicInfo from "./Student/pages/SEF/ViewSEFBasicInfo/ViewSEFBasicInfo";
import ViewSEFVISAInfo from "./Student/pages/SEF/ViewSEFVISAInfo/ViewSEFVISAInfo";
import ViewSEFAllergiesDietaryInfo from "./Student/pages/SEF/ViewSEFAllergiesDietaryInfo/ViewSEFAllergiesDietaryInfo";
import ViewSEFNonFoodAllergiesInfo from "./Student/pages/SEF/ViewSEFNonFoodAllergiesInfo/ViewSEFNonFoodAllergiesInfo";
import ViewSEFPhysicalHealthInfo from "./Student/pages/SEF/ViewSEFPhysicalHealthInfo/ViewSEFPhysicalHealthInfo";
import ViewSEFSENDInfo from "./Student/pages/SEF/ViewSEFSENDInfo/ViewSEFSENDInfo";
import ViewSEFMedicationsInfo from "./Student/pages/SEF/ViewSEFMedicationsInfo/ViewSEFMedicationsInfo";
import ViewSEFMentalHealthInfo from "./Student/pages/SEF/ViewSEFMentalHealthInfo/ViewSEFMentalHealthInfo";
import ViewSEFContactInfo from "./Student/pages/SEF/ViewSEFContactInfo.js/ViewSEFContactInfo";
import ViewSEFDeclarationsInfo from "./Student/pages/SEF/ViewSEFDeclarationsInfo/ViewSEFDeclarationsInfo";
import ViewSEFPhotosInfo from "./Student/pages/SEF/ViewSEFPhotosInfo/ViewSEFPhotosInfo";
import ArrivalDeparture from "./Student/pages/SEF/ArrivalDeparture/ArrivalDeparture";

//Public
import RegistrationForm from "./Public/pages/RegistrationForm.js/RegistrationForm";
import BursaryForm from "./Public/pages/BursaryForm/BursaryForm";
import ECSignUpForm from "./Public/pages/ECSignUpForm/ECSignUpForm";
import GSPTeacherUnSub from "./Public/pages/GSPTeacherUnSub/GSPTeacherUnSub";

// import Test from "./Public/pages/Other/Test";
// import Lumi from "./Public/pages/Other/Lumi";
// import Georgia from "./Public/pages/Other/Georgia";

//Consultant
import HomePageConsultant from "./Consultants/pages/HomePage/HomePageConsultant";
import ConsultantTest from "./Consultants/pages/Test/ConsultantTest";
import LoginConsultant from "./Consultants/pages/Login/LoginConsultant";
import ConsultantHeaderAndDrawer from "./Consultants/components/HeaderAndDrawer/ConsultantHeaderAndDrawer";
import ConsultantMaterials from "./Consultants/pages/Materials/ConsultantMaterials";
import ConsultantBookings from "./Consultants/pages/Bookings/ConsultantBookings";
import ConsultantInvoices from "./Consultants/pages/Invoices/ConsultantInvoices";
import ConsultantLetters from "./Consultants/pages/Letters/ConsultantLetters";
import ConsultantSettings from "./Consultants/pages/Settings/ConsultantSettings";
import CurtAI_Get_Medical_Overview from "./Staff/pages/CurtAI/CurtAI_Get_Medical_Overview/CurtAI_Get_Medical_Overview";
import SXPPreProgramme from "./Staff/pages/Emails/SXPPreProgramme/SXPPreProgramme";
import PreSXPProgrammeData from "./Staff/pages/Settings/PreSXPProgrammeData/PreSXPProgrammeData";
import Reach_Part1_Post from "./Staff/pages/REACH/Reach_Part1_Post/Reach_Part1_Post";
import REACH_Part2_MedicalSync from "./Staff/pages/REACH/REACH_Part2_MedicalSync/REACH_Part2_MedicalSync";
import REACH_Part3_MedicalGeneral from "./Staff/pages/REACH/REACH_Part3_MedicalGeneral/REACH_Part3_MedicalGeneral";
import REACH_Part4_UserDefinedFields from "./Staff/pages/REACH/REACH_Part4_UserDefinedFields/REACH_Part4_UserDefinedFields";
import REACH_Part5_PostAssociations from "./Staff/pages/REACH/REACH_Part5_PostAssociations/REACH_Part5_PostAssociations";
import REACH_Part6_PutAssociations from "./Staff/pages/REACH/REACH_Part6_PutAssociations/REACH_Part6_PutAssociations";
import REACH_Part7_SyncPhotos from "./Staff/pages/REACH/REACH_Part7_SyncPhotos/REACH_Part7_SyncPhotos";
import SXPREACHEmail from "./Staff/pages/Emails/SXPREACHEmail/SXPREACHEmail";

import SXPREACHEmailToParents from "./Staff/pages/Emails/SXPREACHEmailToParents/SXPREACHEmailToParents";
import REACH_Part6_PutAssociationsParents from "./Staff/pages/REACH/REACH_Part6_PutAssociationsParents/REACH_Part6_PutAssociationsParents";
import REACHParentDetails from "./Staff/pages/Settings/REACHParentDetails/REACHParentDetails";
import REACH_Part8_AccomTypeUpdate from "./Staff/pages/REACH/REACH_Part8_AccomTypeUpdate/REACH_Part8_AccomTypeUpdate";
import StaffTestPage from "./Staff/pages/Settings/Test/StaffTestPage";
import EntrDayFour from "./Public/pages/EntrDayFour/EntrDayFour";
import SXPPostProgramme from "./Staff/pages/Emails/SXPPostProgramme.js/SXPPostProgramme";
import EndOfYear from "./Consultants/pages/EndOfYear/EndOfYear";
import EndOfYearStaffView from "./Staff/pages/Agents/EndOfYear/EndOfYearStaffView";

// Create a Layout Component
function Layout({ children }) {
  return (
    <>
      <HeaderAndDrawer />
      {children} {/* This renders the specific page content */}
    </>
  );
}

// Create a Student Layout Component
function StudentLayout({ children }) {
  return (
    <>
      <StudentHeaderAndDrawer />
      {children} {/* This renders the specific page content */}
    </>
  );
}

// Create a Consultant Layout Component
function ConsultantLayout({ children }) {
  return (
    <>
      <ConsultantHeaderAndDrawer />
      {children} {/* This renders the specific page content */}
    </>
  );
}

function AppVersion2_2() {
  function Example() {
    useEffect(() => {
      document.title = "InvestINternal";
    }, []);
  }
  Example();

  return (
    <>
      <StaffAuthProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Staff/login" element={<Login />} />
          <Route
            path="/Staff"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <HomePage />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/Contact"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <Contact />
                </Layout>
              </StaffProtectedRoute>
            }
          />{" "}
          <Route
            path="/Staff/ViewSchools"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewSchools />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewSchoolEventsOld"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewSchoolEventsOld />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewSchool/:id"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewSchool />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/LogSchoolEvent/:id/:Contactid"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <LogSchoolEvent />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewAgencies"
            element={
              <StaffProtectedRoute>
                <Layout>
                  {localStorage.getItem("Username") === "curtis@investin.org" ||
                  localStorage.getItem("Username") === "rebecca@investin.org" ||
                  localStorage.getItem("Username") === "shu@investin.org" ||
                   localStorage.getItem("Username") === "caitlin@investin.org" ||
                  localStorage.getItem("Username") ===
                    "richardlawless@investin.org" ||
                    localStorage.getItem("Username") ===
                    "rebeccaseymour@investin.org" ||
                    localStorage.getItem("Username") ===
                    "carla.jones@dukesplus.com" ||
                  localStorage.getItem("Username") === "amy@investin.org" ||
                  localStorage.getItem("Username") === "arsbi@investin.org" ||
                  localStorage.getItem("Username") === "hitesh@investin.org" ||
                  localStorage.getItem("Username") ===
                    "shameer@investin.org" ? (
                    <ViewAgencies />
                  ) : (
                    <NoPermissions />
                  )}
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/EndOfYearStaffView"
            element={
              <StaffProtectedRoute>
                <Layout>
                  {localStorage.getItem("Username") === "curtis@investin.org" ||
                  localStorage.getItem("Username") === "rebecca@investin.org" ||
                  localStorage.getItem("Username") === "shu@investin.org" ||
                   localStorage.getItem("Username") === "caitlin@investin.org" ||
                  localStorage.getItem("Username") ===
                    "richardlawless@investin.org" ||
                    localStorage.getItem("Username") ===
                    "rebeccaseymour@investin.org" ||
                    localStorage.getItem("Username") ===
                    "carla.jones@dukesplus.com" ||
                  localStorage.getItem("Username") === "amy@investin.org" ||
                  localStorage.getItem("Username") === "arsbi@investin.org" ||
                  localStorage.getItem("Username") === "hitesh@investin.org" ||
                  localStorage.getItem("Username") ===
                    "shameer@investin.org" ? (
                    <EndOfYearStaffView />
                  ) : (
                    <NoPermissions />
                  )}
                </Layout>
              </StaffProtectedRoute>
            }
          />
          
          <Route
            path="/Staff/ViewAgency/:id"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewAgency />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewECs"
            element={
              <StaffProtectedRoute>
                <Layout>
                  {localStorage.getItem("Username") === "curtis@investin.org" ||
                  localStorage.getItem("Username") === "rebecca@investin.org" ||
                  localStorage.getItem("Username") === "amy@investin.org" ||
                  localStorage.getItem("Username") ===
                    "katherine.tarren@investin.org" ||
                  localStorage.getItem("Username") === "shu@investin.org" ||
                  localStorage.getItem("Username") ===
                    "richardlawless@investin.org" ||  localStorage.getItem("Username") === "caitlin@investin.org" ||

 localStorage.getItem("Username") ===
                    "rebeccaseymour@investin.org" ||
                    localStorage.getItem("Username") ===
                    "carla.jones@dukesplus.com" ||

                  localStorage.getItem("Username") === "arsbi@investin.org" ||
                  localStorage.getItem("Username") === "hitesh@investin.org" ||
                  localStorage.getItem("Username") ===
                    "shameer@investin.org" ? (
                    <ViewECs />
                  ) : (
                    <NoPermissions />
                  )}
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/NoPermissions"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <NoPermissions />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewEC/:id/:Agencyid"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewEC />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewRegisters"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewRegisters />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/LiveTable"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <LiveTable />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewAttendee/:id"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewAttendee />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/SEFRegisters"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <SEFRegisters />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewSEFReview/:id"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewSEFReview />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ArrivalDepartureHome"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ArrivalDepartureHome />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewPortalEmails"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewPortalEmails />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/SEFEmails"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <SEFEmails />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/SummerLetters"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <SummerLetters />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/GSPBookingEmails"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <GSPBookingEmails />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ArrivalDepartureEmails"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ArrivalDepartureEmails />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ArrivalDepartureConfirmationEmails"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ArrivalDepartureConfirmationEmails />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/SXPPreProgramme"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <SXPPreProgramme />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/SXPPostProgramme"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <SXPPostProgramme />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/SXPREACHEmail"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <SXPREACHEmail />
                </Layout>
              </StaffProtectedRoute>
            }
          />
           <Route
            path="/Staff/StaffTestPage"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <StaffTestPage />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          
          <Route
            path="/Staff/SXPREACHEmailToParents"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <SXPREACHEmailToParents />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewOrders"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewOrders />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewInvoices"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewInvoices />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewInvoice/:id"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewInvoice />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewTransactions"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewTransactions />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewTransaction/:id"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewTransaction />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ImportTransactions"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ImportTransactions />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ViewWebinar"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ViewWebinar />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/CurtAI"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <CurtAI />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/CurtAI_Get_Medical_Overview"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <CurtAI_Get_Medical_Overview />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/PowerBI/Schools"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <PowerBISchools />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/PowerBI/Partnerships"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <PowerBIPartnerships />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/PowerBI/Invoices"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <PowerBIInvoices />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/PowerBI/Registers"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <PowerBIRegisters />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/PowerBI/MasterSales"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <PowerBIMasterSales />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/PowerBI/Logs"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <PowerBILogs />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/PowerBI/STX"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <PowerBISTX />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/AssignAttendeeToSchool"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <AssignAttendeeToSchool />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/AssignSchoolToCountry"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <AssignSchoolToCountry />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/AssignSXPAttendeeToSchool"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <AssignSXPAttendeeToSchool />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/AssignSchoolToHubSpot"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <AssignSchoolToHubSpot />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ProgrammeList"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <ProgrammeList />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/PreSXPProgrammeData"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <PreSXPProgrammeData />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/REACHParentDetails"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACHParentDetails />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/REACH_Part8_AccomTypeUpdate"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACH_Part8_AccomTypeUpdate />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/TCSCertificates"
            element={
              <StaffProtectedRoute>
                <Layout>
                  {localStorage.getItem("Username") === "curtis@investin.org" ||
                  localStorage.getItem("Username") === "louise@investin.org" ? (
                    <TCSCertificates />
                  ) : (
                    <NoPermissions />
                  )}
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/ImportTCSCertificates"
            element={
              <StaffProtectedRoute>
                <Layout>
                  {localStorage.getItem("Username") === "curtis@investin.org" ||
                  localStorage.getItem("Username") === "louise@investin.org" ? (
                    <ImportTCSCertificates />
                  ) : (
                    <NoPermissions />
                  )}
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/InvoiceReminders"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <InvoiceReminders />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/Reach_Part1_Post"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <Reach_Part1_Post />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/Reach_Part2_MedicalSync"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACH_Part2_MedicalSync />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/REACH_Part3_MedicalGeneral"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACH_Part3_MedicalGeneral />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/REACH_Part4_UserDefinedFields"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACH_Part4_UserDefinedFields />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/REACH_Part5_PostAssociations"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACH_Part5_PostAssociations />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/REACH_Part6_PutAssociations"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACH_Part6_PutAssociations />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/REACH_Part6_PutAssociationsParents"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACH_Part6_PutAssociationsParents />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route
            path="/Staff/REACH_Part7_SyncPhotos"
            element={
              <StaffProtectedRoute>
                <Layout>
                  <REACH_Part7_SyncPhotos />
                </Layout>
              </StaffProtectedRoute>
            }
          />
          <Route path="/Staff/secret" element={<Secret />} />
        </Routes>
      </StaffAuthProvider>

      <StudentAuthProvider>
        <Routes>
          <Route
            path="Student/login/:urlUsername/:urlPassword"
            element={<LoginStudent />}
          />
          <Route path="Student/login" element={<LoginStudent />} />
          <Route
            path="/Student"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <HomePageStudent />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          {/* WEF */}
          <Route
            path="/Student/ViewBasicInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewBasicInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewGeneralInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewGeneralInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />{" "}
          <Route
            path="/Student/ViewEmergancyMedicalInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewEmergancyMedicalInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSENDInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSENDInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewPermissionsInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewPermissionsInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewContactInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewContactInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          {/* Summer SEF */}
          <Route
            path="/Student/ViewSEFGeneralInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFGeneralInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFBasicInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFBasicInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />{" "}
          <Route
            path="/Student/ViewSEFContactInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFContactInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFVISAInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFVISAInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFPhotosInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFPhotosInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFAllergiesDietaryInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFAllergiesDietaryInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFNonFoodAllergiesInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFNonFoodAllergiesInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFPhysicalHealthInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFPhysicalHealthInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFMentalHealthInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFMentalHealthInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFSENDInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFSENDInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFMedicationsInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFMedicationsInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ViewSEFDeclarationsInfo/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ViewSEFDeclarationsInfo />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
          <Route
            path="/Student/ArrivalDeparture/:id"
            element={
              <StudentProtectedRoute>
                <StudentLayout>
                  <ArrivalDeparture />
                </StudentLayout>
              </StudentProtectedRoute>
            }
          />
        </Routes>
      </StudentAuthProvider>

      <ConsultantAuthProvider>
        <Routes>
          <Route
            path="Consultant/login/:urlUsername/:urlPassword"
            element={<LoginConsultant />}
          />
          <Route path="Consultant/login" element={<LoginConsultant />} />
          <Route
            path="/Consultant"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <HomePageConsultant />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/Home"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <HomePageConsultant />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ConsultantTest"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ConsultantTest />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ConsultantBookings"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ConsultantBookings />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ConsultantInvoices"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ConsultantInvoices />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          /> <Route
            path="/Consultant/EndOfYear"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <EndOfYear />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          
          <Route
            path="/Consultant/ConsultantMaterials"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ConsultantMaterials />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ConsultantLetters"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ConsultantLetters />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ConsultantSettings"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ConsultantSettings />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          {/* ////////SEF Stuff */}
          <Route
            path="/Consultant/ViewSEFBasicInfo/:id"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ViewSEFBasicInfo />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ViewSEFContactInfo/:id"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ViewSEFContactInfo />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ViewSEFGeneralInfo/:id"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ViewSEFGeneralInfo />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ViewSEFVISAInfo/:id"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ViewSEFVISAInfo />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ViewSEFPhotosInfo/:id"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ViewSEFPhotosInfo />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
          <Route
            path="/Consultant/ArrivalDeparture/:id"
            element={
              <ConsultantProtectedRoute>
                <ConsultantLayout>
                  <ArrivalDeparture />
                </ConsultantLayout>
              </ConsultantProtectedRoute>
            }
          />
        </Routes>
      </ConsultantAuthProvider>

      <Routes>
        <Route
          path="/Public/RegistrationForm/:id"
          element={<RegistrationForm />}
        />
        <Route path="/Public/ECSignUpForm/:id" element={<ECSignUpForm />} />
        <Route path="/Public/BursaryForm/:id" element={<BursaryForm />} />
        <Route
          path="/Public/GSPTeacherUnSub/:TeacherEmail"
          element={<GSPTeacherUnSub />}
        />
        <Route path="/Public/EntrDayFour" element={<EntrDayFour />} />
        {/* <Route path="/Test" element={<Test />} />
        <Route path="/Lumi" element={<Lumi />} />
        <Route path="/Georgia" element={<Georgia />} /> */}
      </Routes>
    </>
  );
}

export default AppVersion2_2;
